<script setup lang="ts">
import { MtdButton, MtdTypography } from '@paygine/mtd-uikit'
import { storeToRefs } from 'pinia'

import type { Steps } from '@/shared/constants'

import { userDataModel } from '@/entities/user-data'
import { useConfig } from '@/shared/config'
import { ErrorIcon, SuccessIcon } from '@/shared/icons'

const { config } = useConfig()

const emit = defineEmits<{
    goto: [Steps]
}>()

const store = userDataModel.useModel()
const { fetchUserData, isFetchingData } = store
const { userData } = storeToRefs(store)

async function updateData() {
    const data = await fetchUserData()

    if (!data) return

    if (!userData.value?.grn_list?.length) {
        emit('goto', 'addCar')
        return
    }

    if (!userData.value?.payment_methods?.sbp?.length) {
        emit('goto', 'select-pay-method')
        return
    }

    emit('goto', 'sub_management')
}
</script>

<template>
    <div
        v-if="!!config?.subscriptionState"
        class="notify"
    >
        <SuccessIcon class="notify__icon" />

        <MtdTypography
            variant="header-5"
            class="notify__title"
            tag="h1"
            >Подписка успешно <br />
            оформлена
        </MtdTypography>

        <MtdTypography
            tag="p"
            variant="textbody-2"
            class="notify__subtitle"
            >Вы можете отменить её в любой момент</MtdTypography
        >

        <MtdButton
            tag="button"
            class="mt-24"
            :is-loading="isFetchingData"
            variant="main-secondary"
            @click="updateData"
            >Понятно</MtdButton
        >
    </div>

    <div
        v-else
        class="notify"
    >
        <ErrorIcon class="notify__icon" />

        <MtdTypography
            variant="header-5"
            class="notify__title"
            tag="h1"
            >Не удалось оформить <br />
            подписку
        </MtdTypography>

        <MtdButton
            tag="button"
            class="mt-24"
            variant="main-secondary"
            :is-loading="isFetchingData"
            @click="updateData"
            >Попробовать снова</MtdButton
        >
    </div>
</template>

<style src="./VNotify.scss" lang="scss"></style>
